module.exports = __webpack_public_path__ + "img/okchain.faf6c3ef.png";